<app-workers-detail-historic-table
  *ngIf="historicSection === 'table'">
</app-workers-detail-historic-table>

<app-workers-detail-historic-form
  *ngIf="historicSection === 'form'">
</app-workers-detail-historic-form>